module.exports = __webpack_public_path__ + "icons.8e3c7f5520f5ae906c6c.eot";


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/assets/semantic/themes/default/assets/fonts/icons.eot
// module id = ../../../../../src/assets/semantic/themes/default/assets/fonts/icons.eot
// module chunks = styles